export default __webpack_public_path__ + "static/media/header-background.06902ffb.jpg";